import React from "react";
import { Icon } from "@iconify/react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/common/PageHeader";
import ProductGrid from "../../components/store/ProductGrid";
import StoreFilters from "../../components/store/StoreFilters";

const ProductGridPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Loja" />

        {/* Header Section */}
        <PageHeader
          icon="mdi:store"
          title="Loja"
          subtitle="Descubra produtos digitais incríveis e comece a ganhar dinheiro"
        />

        {/* Store Filters */}
        <StoreFilters />

        {/* ProductGrid */}
        <ProductGrid />
      </MasterLayout>
    </>
  );
};

export default ProductGridPage; 
